export type SevColor = 'success' | 'info' | 'warning' | 'error';

/** Skor formülü açıklaması — ekranlarda gösterilir. */
export const SCORE_FORMULA_TR =
  'Skor = 3×Devamsızlık + 1×Geç + 1×Erken + 0.5×Unutulan çıkış · yüksek skor = daha düzensiz · ' +
  'risk bandı, skorun iş günü sayısına oranıyla belirlenir.';

/**
 * Ham skoru insan-anlaşılır risk bandına çevirir. Oran = skor / (iş günü × 3),
 * yani "her gün devamsız" senaryosuna göre yüzde — tarih aralığı uzunluğundan
 * bağımsız karşılaştırılabilir.
 */
export function severity(
  score: number,
  expectedWorkdays: number
): { label: string; color: SevColor; pct: number } {
  const max = Math.max(1, expectedWorkdays * 3);
  const pct = Math.min(100, Math.round((score / max) * 100));
  if (score <= 0) return { label: 'Sorunsuz', color: 'success', pct: 0 };
  if (pct < 15) return { label: 'Düşük', color: 'info', pct };
  if (pct < 40) return { label: 'Orta', color: 'warning', pct };
  return { label: 'Yüksek', color: 'error', pct };
}
